<template>
  <div class="h-screen flex flex-col items-center relative overflow-hidden">
    <LogoSvg />
    <div
      class="flex justify-center items-center w-3/12 absolute top-3 left-1/2 -translate-x-1/2"
    >
      <img src="@/assets/logo-1.webp" alt="logo" />
    </div>
    <!-- Main Content -->
    <div
      class="px-4 p-1 flex flex-col justify-center bg-transparent shadow-md drop-shadow-2xl lg:p-2 rounded-md mb-12"
    >
      <div class="flex justify-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="#9d2890"
          class="h-24 w-24 animate-bounce"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
          />
        </svg>
      </div>
      <div class="text-white text-center text-lg font-bold">
        Pending Payment...
      </div>
    </div>
  </div>
</template>

<script>
import LogoSvg from "@/components/svg/LogoSvg.vue";
import { paymentGatewaysOpto } from "@/constants";
import { useFawryStore } from "@/stores/fawry";
import { mapActions } from "pinia";
import { useToast } from "vue-toastification";
// import { useAuthStore } from "@/stores/auth";
// import { mapActions } from "pinia";
export default {
  components: {
    LogoSvg,
  },
  data() {
    return {
      successStatus: false,
      isMobile: false,
      showBottomSheet: false,
      paymentGateways: paymentGatewaysOpto,
      pollingInterval: null,
      timeoutInterval: null,
      pollingStartTime: null,
      toast:useToast(),
      merchantRefNumber: null,
    };
  },
  methods: {
    ...mapActions(useFawryStore, ["verifyFawryPaymentStatus"]),
    async checkFawry() {
         this.merchantRefNumber = this.$route.query.transactionId;
        if (!this.merchantRefNumber) {
            this.toast.error("Transaction ID is missing for Fawry payment.");
          this.$router.push({ name: 'auth.payment.failure' });
        }
    return this.verifyFawryPaymentStatus(this.merchantRefNumber)
    },
    checkPaymentGateway() {
      const paymentGateway = this.$route.params.payment_gateway;
      //  return the value from the array
      if (this.paymentGateways.includes(paymentGateway)) {
        return paymentGateway;
      }else {
        this.$router.push({ name: 'auth.payment.failure' });
      }
      // return this.paymentGateways.includes(paymentGateway);
    },
    // make pooling request to check payment status
    async pollPaymentStatus() {
      try {
        const paymentGateway = this.$route.params.payment_gateway;
        let statusResponse = null;

        // Handle different payment gateways
        switch (paymentGateway) {
          case 'fawry-eg':
             
            statusResponse = await this.checkFawry();
            break;
          
          case 'stripe':
            // TODO: Implement Stripe payment status verification
            // const paymentIntentId = this.$route.query.payment_intent;
            // statusResponse = await this.verifyStripePaymentStatus(paymentIntentId);
            console.log('Stripe polling not implemented yet');
            break;
          
          case 'yallapay':
            // TODO: Implement YallaPay payment status verification
            // const merchantRefNumber = this.$route.query.transaction_id;
            // statusResponse = await this.verifyYallaPayPaymentStatus(merchantRefNumber);
            console.log('YallaPay polling not implemented yet');
            break;
          
          default:
            console.warn(`Unknown payment gateway: ${paymentGateway}`);
            return null;
        }

        return statusResponse;
      } catch (error) {
        console.error("Error polling payment status:", error);
        throw error;
      }
    },

    // Start polling for payment status every 5 seconds
    startPolling() {
      this.pollingStartTime = Date.now();
      
      // Set up 5-minute timeout
      this.timeoutInterval = setTimeout(() => {
        console.log("Payment polling timeout after 5 minutes");
        this.clearPolling();
        // Redirect to failure page after 5 minutes
        const paymentGateway = this.$route.params.payment_gateway;
        this.$router.push({ 
          name: 'auth.payment.failure',
          params: { payment_gateway: paymentGateway }
        });
      }, 5 * 60 * 1000); // 5 minutes in milliseconds

      this.pollingInterval = setInterval(async () => {
        try {
          const response = await this.pollPaymentStatus();
          
         

          // Check if payment is successful based on different response structures
          const data = this.checkPaymentSuccess(response);
          
          if (data.success && data.isPaid) {
            this.clearPolling();
            // Redirect to success page with payment gateway parameter
            const paymentGateway = this.$route.params.payment_gateway;
            this.$router.push({ 
              name: 'auth.payment.success',
              params: { payment_gateway: paymentGateway }
            });
          }else if (data.failure) {
            this.clearPolling();
           this.$router.push({ name: 'auth.payment.failure' });
          }
        } catch (error) {
          console.error("Polling error:", error);
          // Continue polling even on error unless it's a critical error
        }
      }, 5000); // Poll every 5 seconds
    },

    // Check if payment is successful based on response structure
    checkPaymentSuccess(response) {
      if (!response || !response.data) {
        return false;
      }

      // Handle different response structures from different payment gateways
      return response.data 
      
    },

    // Clear the polling interval and timeout
    clearPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
      if (this.timeoutInterval) {
        clearTimeout(this.timeoutInterval);
        this.timeoutInterval = null;
      }
    },
  },

  async created() {
    this.checkPaymentGateway();
    // Start polling for payment status
    this.startPolling();
  },

  // Clean up interval when component is destroyed
  beforeUnmount() {
    this.clearPolling();
  },
};
</script>

<style scoped>
/* Your existing styles */
</style>

<style scoped></style>
